import { useContext, useEffect, useState } from "react";
import "./style.scss";
import style from "./style.module.scss";
import { DatePicker, Form, Input, InputNumber, Select, TimePicker } from "antd";
import { FormProvider } from "../../../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import { useNavigate } from "react-router";
import { CommercialOperation } from "../../../core/_request";
import { DynamicUploadFile } from "../../../../../common/components/Upload/DynamicUploadFile";
import { FormatDate } from "../../../../../utilities/formatDate";
import Spinner from "../../../../../common/components/Spinner/Spinner";
import { excludeEmpty } from "../../../../../utilities/exclude";
import { useQueryCustomersForSelect } from "../../../../customers/core/_hooks";
import {
  // useQueryOperationsShiftingForSelect,
  useQueryOperationsTypeForSelect,
} from "../../../core/_hooks";
import { OperationContext } from "../CreateOperation";
import { rangeOfNumber } from "../../../../../utilities/formatNUmber";
import dayjs from "dayjs";
import { useOperationType } from "../../../core/_context";

export const TeamOrderForm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const operationType = useOperationType();

  const { initialValue } = useContext(OperationContext);

  const { data: customers, isLoading: isLoadingCustomers } =
    useQueryCustomersForSelect();

  const { data: operationTypes, isLoading: isLoadingOperationsTypes } =
    useQueryOperationsTypeForSelect();

  // const { data: operationShiftings, isLoading: isLoadingOperationShiftin } =
  //   useQueryOperationsShiftingForSelect();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    form.setFieldsValue(initialValue);
  }, [initialValue]);

  const onChangeCustomer = (e: any) => {
    const category = customers?.find(
      (item: any) => item?.["@id"] === e?.value
    )?.customerCategory;
    console.log(category);

    if (category) {
      form?.setFieldValue("customerCategory", {
        label: category?.name,
        value: category?.["@id"],
      });
    }
  };

  const handleSubmit = async (value: any) => {
    try {
      setIsLoadingSubmit(true);

      const dataToPost = {
        ...value,
        // Format all file
        ...(value?.holdsValueLength
          ? {
              holds: rangeOfNumber(value?.holdsValueLength),
            }
          : {}),

        teamOrderFile: value?.teamOrderFile
          ? value?.teamOrderFile?.value
          : null,

        arrivalNoticeFile: value?.arrivalNoticeFile
          ? value?.arrivalNoticeFile?.value
          : null,

        embarkationPlanFile: value?.embarkationPlanFile
          ? value?.embarkationPlanFile?.value
          : null,

        debarkationPlanFile: value?.debarkationPlanFile
          ? value?.debarkationPlanFile?.value
          : null,

        // Format select

        operationType: value?.operationType
          ? value?.operationType?.value
          : null,

        operationShifting: value?.operationShifting
          ? value?.operationShifting?.value
          : null,

        customer: value?.customer ? value?.customer?.value : null,

        // Format date

        endAt: value?.endAt
          ? FormatDate.formatDateToPost(value?.endAt, true)
          : null,

        startAt: value?.startAt
          ? FormatDate.formatDateToPost(value?.startAt, true)
          : null,

        estimatedArrivalAt: value?.estimatedArrivalAt
          ? FormatDate.formatDateToPost(value?.estimatedArrivalAt, true)
          : null,

        receiptRequestAt: value?.receiptRequestAt
          ? FormatDate.formatDateToPost(value?.receiptRequestAt, true)
          : null,
      };
      delete dataToPost.holdsValueLength;
      delete dataToPost.customerCategory;

      // const res =
      await CommercialOperation.updateOperations(excludeEmpty(dataToPost));

      // if (
      //   res?.status === HttpStatusCode.Ok ||
      //   res?.status === HttpStatusCode.Created
      // ) {
      //   navigate(-1);
      // }
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setIsLoadingSubmit(false);
      }, 3000);
    }
  };

  return (
    <>
      <FormProvider
        Form={Form}
        form={form}
        debug
        onFinish={(values: any) => {
          handleSubmit(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            name={"id"}
            label="ID"
            customInput={<Input />}
          />
        </div>
        <div className={style.wrapper}>
          {/* information section  */}
          <div className={style.form}>
            <div className="">
              <span className={style.title}>
                {" "}
                {"Informations de la demande"}{" "}
              </span>
            </div>
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"reference"}
                  label="Référence"
                  customInput={<Input />}
                />
              </div>

              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"receiptRequestAt"}
                  label="Date de réception de la demande"
                  customInput={
                    <DatePicker
                      placeholder="--/--/----"
                      className={style.form__date}
                      showNow={false}
                      format={"DD/MM/YYYY"}
                      allowClear={false}
                    />
                  }
                />
              </div>
              {window.innerWidth > 1024 && (
                <div className={style.form__item}></div>
              )}
            </div>

            {/* Next sub-section */}
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"customer"}
                  label="Client"
                  customInput={
                    <Select
                      className={style.form__select}
                      labelInValue
                      loading={isLoadingCustomers}
                      options={customers}
                      onChange={(e) => onChangeCustomer(e)}
                      disabled
                    />
                  }
                />
              </div>

              {/* <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"customerCategory"}
                  label="Catégorie du client"
                  customInput={
                    <Select className={style.form__select} disabled />
                  }
                />
              </div> */}

              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"teamOrderFile"}
                  label="Pièce jointe (Commande équipe)"
                  customInput={
                    <DynamicUploadFile form={form} name={"teamOrderFile"} />
                  }
                />
              </div>

              {window.innerWidth > 1024 && (
                <div className={style.form__item}></div>
              )}
            </div>

            {/* Next sub-section */}
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"arrivalNoticeFile"}
                  label="Pièce jointe (Avis d'arrivée)"
                  customInput={
                    <DynamicUploadFile form={form} name={"arrivalNoticeFile"} />
                  }
                />
              </div>

              <div className={style.form__item}></div>
              {window.innerWidth > 1024 && (
                <div className={style.form__item}></div>
              )}
            </div>
          </div>

          {/* operation section  */}
          <div className={style.form}>
            <div className="">
              <span className={style.title}> {"Opérations liées"} </span>
            </div>

            {/* Next sub-section */}
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"ship"}
                  label="Navire(s) à opérer"
                  customInput={<Input />}
                />
              </div>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"holdsValueLength"}
                  label="Nombre de cales"
                  customInput={<InputNumber className="w-100" />}
                />
              </div>

              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"travelReference"}
                  label="Référence du voyage"
                  customInput={<Input disabled={operationType === "cabotage" ? true : false}/>}
                />
              </div>
            </div>

            {/* Next sub-section */}
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"estimatedArrivalAt"}
                  label="Date d'arrivée estimée"
                  customInput={
                    <DatePicker
                      placeholder="--/--/----"
                      className={style.form__date}
                      showNow={false}
                      allowClear={false}
                      format={"DD/MM/YYYY"}
                    />
                  }
                />
              </div>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"estimatedArrivalAt"}
                  label="Heure"
                  customInput={
                    <TimePicker
                      className={style.form__time}
                      placeholder="--/--"
                      showNow={false}
                      needConfirm={false}
                      format={"HH:mm"}
                      allowClear={false}
                    />
                  }
                />
              </div>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  name={"operationType"}
                  label="Type d'opération"
                  disabled
                  customInput={
                    <Select
                      className={style.form__select}
                      loading={isLoadingOperationsTypes}
                      options={operationTypes}
                      disabled
                    />
                  }
                />
              </div>

              {window.innerWidth > 1024 && (
                <div className={style.form__item}>
                  {/* <SimpleInput
                    Form={Form}
                    name={"Heure"}
                    label="Opération de panneau de cale"
                    customInput={
                      <div>
                        <Checkbox>Oui</Checkbox>
                        <Link to={"#"}>Voir</Link>
                      </div>
                    }
                  /> */}
                </div>
                )}
            </div>
          </div>

          {/* Date operation section  */}
          <div className="d-flex gap-4 flex-wrap">
            <div className={`${style.form} ${style.form__flex_1}`}>
              <div className="">
                <span className={style.title}> {"Début de l'opération"} </span>
              </div>
              <div className={style.form__item_wrapper}>
                <div className={style.form__item}>
                  <SimpleInput
                    Form={Form}
                    name={"startAt"}
                    label="Date"
                    customInput={
                      <DatePicker
                        placeholder="--/--/----"
                        className={style.form__date}
                        showNow={false}
                        allowClear={false}
                        format={"DD/MM/YYYY"}
                        disabled
                      />
                    }
                  />
                </div>

                <div className={style.form__item}>
                  <SimpleInput
                    Form={Form}
                    name={"startAt"}
                    label="Heure"
                    customInput={
                      <TimePicker
                        className={style.form__time}
                        placeholder="--/--"
                        showNow={false}
                        needConfirm={false}
                        allowClear={false}
                        format={"HH:mm"}
                        disabled
                      />
                    }
                  />
                </div>
              </div>
            </div>
            <div className={`${style.form} ${style.form__flex_1}`}>
              <div className="">
                <span className={style.title}> {"Fin de l'opération"} </span>
              </div>
              <div className={style.form__item_wrapper}>
                <div className={style.form__item}>
                  <SimpleInput
                    Form={Form}
                    name={"endAt"}
                    label="Date"
                    customInput={
                      <DatePicker
                        placeholder="--/--/----"
                        className={style.form__date}
                        showNow={false}
                        allowClear={false}
                        format={"DD/MM/YYYY"}
                        disabled
                      />
                    }
                  />
                </div>

                <div className={style.form__item}>
                  <SimpleInput
                    Form={Form}
                    name={"endAt"}
                    label="Heure"
                    customInput={
                      <TimePicker
                        className={style.form__time}
                        placeholder="--/--"
                        showNow={false}
                        needConfirm={false}
                        format={"HH:mm"}
                        allowClear={false}
                        disabled
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Plan section  */}
          <div className={style.form__item_wrapper}>
            { operationType === "sales" && (
                <div className={style.form__item}>
                  <SimpleInput
                    Form={Form}
                    name={"debarkationPlanFile"}
                    label="Plan de débarquement"
                    customInput={
                      <DynamicUploadFile form={form} name={"debarkationPlanFile"} />
                    }
                  />
                </div>
            )}
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                name={"embarkationPlanFile"}
                label="Plan d'embarquement"
                customInput={
                  <DynamicUploadFile form={form} name={"embarkationPlanFile"} />
                }
              />
            </div>
            <div className={style.form__item}></div>
          </div>
        </div>

        <div className={style.footer}>
          <CustomButton
            type="submit"
            backgroundColor="#5F99FE"
            disabled={isLoadingSubmit}
            style={{
              minWidth: "120px",
            }}
          >
            <div className={style.footer__content}>
              {isLoadingSubmit ? <Spinner /> : "Enregistrer"}
            </div>
          </CustomButton>
        </div>
      </FormProvider>
    </>
  );
};
